// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".6b880fbcf6942cf2cff58ba381bca8c3.js";
};